import axios from "axios";

export const http = axios.create({
  // baseURL: process.env.VUE_APP_URL_API,
  // baseURL: "http://192.168.0.22:3002",
  // baseURL: "http://192.168.1.67:3000",
  baseURL: "https://api.cosmoscode.com.br/lucromil/",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      sessionStorage.token ? JSON.parse(sessionStorage.token) : ""
    }`
  }
});
